import { call, put, takeEvery } from 'redux-saga/effects';
import * as type from '../../ActionTypes';
import { getNotificationService, updateNotificationService } from '../../../services/firebase';

function* fetchNotification(): any {
  try {
    const notification = yield call(getNotificationService);
    if (notification) {
      yield put({
        type: type.GET_NOTIFICATION_SUCCESS,
        notifications: notification
      });
    }
  } catch (e: any) {
    yield put({
      type: type.GET_NOTIFICATION_FAILURE,
      error: e.message
    });
  }
}

function* updateNotification(action: any): any {
  try {
    yield call(updateNotificationService, action.id, action.payload);
    const notification = yield call(getNotificationService);
    if (notification) {
      yield put({
        type: type.GET_NOTIFICATION_SUCCESS,
        notifications: notification
      });
    }
  } catch (e: any) {
    yield put({
      type: type.GET_NOTIFICATION_FAILURE,
      error: e.message
    });
  }
}

function* notificationSaga() {
  yield takeEvery(type.GET_NOTIFICATION_REQUEST, fetchNotification);
  yield takeEvery(type.UPDATE_NOTIFICATION_REQUEST, updateNotification);
}

export default notificationSaga;
